function contactFormRecaptchaCallback() {
    const form = $("#contact-form").get(0);
    if (form.isValid()) {
        form.submit();
    }
}

function resetRecaptcha() {
    grecaptcha.reset();
}